import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyWelcome() {
    return (
        <OnboardingBody title='Welcome to your new sales process!'>
            <div>
                <p>We’ve designed this based on your answers.</p>
                <p>
                    We’re going to introduce a few terms and give you some tips on what to do next.
                </p>
                <p>
                    Don’t worry about setting everything up perfectly right away. Nutshell helps you
                    tune and learn as you sell!
                </p>
            </div>
        </OnboardingBody>
    );
}
